import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import PageSection from "../../components/pageSection/pageSection.js"

import styles from "./confettiHero.module.scss"

const ConfettiHero = ({ children, color, HeroImage }) => {
  const data = useStaticQuery(graphql`
    query {
      confetti: file(relativePath: { eq: "faq/confetti.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 368
            placeholder: NONE
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      blueOval: file(relativePath: { eq: "faq/blue-oval.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 368
            placeholder: NONE
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      yellowOval: file(relativePath: { eq: "faq/yellow-oval.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 368
            placeholder: NONE
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      greenOval: file(relativePath: { eq: "faq/green-oval.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 368
            placeholder: NONE
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      feature: file(relativePath: { eq: "faq/faq-feature.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 541
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `)

  let ovalImg = data.blueOval
  if (color === 'yellow') {
    ovalImg = data.yellowOval
  }
  if (color === 'green') {
    ovalImg = data.greenOval
  }

  return (
    <PageSection
      backgroundColor="#eff3f9"
      collapseAt="small"
      LeftComponent={() =>
        <div className={styles.featureImgContainer}>
          <HeroImage />
        </div>
      }
      RightComponent={() =>
        <div className={styles.heroImgContainer}>
          <div className={styles.confettiImg}>
            <GatsbyImage
              image={getImage(data.confetti)}
              alt="Till app on an iPhone"
              width={368}
            />
          </div>
          <div className={styles.blueOvalContainer}>
            <GatsbyImage
              image={getImage(ovalImg)}
              alt="Blue semi-circle"
              width={368}
              className={styles.blueOval}
            />
          </div>
        </div>
      }
    >
      {children}
    </PageSection>
  )
}

export { ConfettiHero }
